import { Controller } from "@hotwired/stimulus"

// Stimulus controller for the visual timeline component.
//
// Handles:
// - Expand/collapse of individual node detail panels
// - "Show more" to reveal all entries (re-renders full timeline via Turbo)
//
// Usage (applied automatically by the _timeline.html.erb partial):
//   <div data-controller="timeline" data-timeline-page-size-value="20">
//     ...
//   </div>
//
export default class extends Controller {
  static targets = ["detail", "toggle", "showMore"]

  static values = {
    pageSize: { type: Number, default: 20 },
    recordType: String,
    recordId: Number
  }

  // Toggle an individual detail panel open/closed.
  toggleDetail(event) {
    const button = event.currentTarget
    const index = this.toggleTargets.indexOf(button)
    if (index < 0) return

    const detail = this.detailTargets[index]
    if (!detail) return

    const isExpanded = button.getAttribute("aria-expanded") === "true"

    if (isExpanded) {
      detail.classList.remove("show")
      button.setAttribute("aria-expanded", "false")
      const textEl = button.querySelector(".toggle-text")
      if (textEl) textEl.textContent = "Show details"
      // Swap chevron icon from down to right
      this._swapChevron(button, "fa-chevron-down", "fa-chevron-right")
    } else {
      detail.classList.add("show")
      button.setAttribute("aria-expanded", "true")
      const textEl = button.querySelector(".toggle-text")
      if (textEl) textEl.textContent = "Hide details"
      // Swap chevron icon from right to down
      this._swapChevron(button, "fa-chevron-right", "fa-chevron-down")
    }
  }

  // "Show all N entries" button: reload the page with a query param that
  // tells the server to skip pagination (simple approach without extra endpoint).
  loadMore(event) {
    const button = event.currentTarget
    const recordType = button.dataset.timelineRecordTypeValue
    const recordId = button.dataset.timelineRecordIdValue

    // Append ?timeline_all=1 to the current URL so the controller/helper
    // can detect it and render without the page-size limit.
    const url = new URL(window.location.href)
    url.searchParams.set("timeline_all", "1")
    window.location.href = url.toString()
  }

  // Helper: swap one FA class for another inside a button's <i> element.
  _swapChevron(button, from, to) {
    const icon = button.querySelector("i")
    if (icon) {
      icon.classList.remove(from)
      icon.classList.add(to)
    }
  }
}
